function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1559",
  "data-name": "Group 1559",
  transform: "translate(-1549.906 -4003.155)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Icon_awesome-arrow-down",
  "data-name": "Icon awesome-arrow-down",
  d: "M21.526,12.129l1.151,1.151a1.239,1.239,0,0,1,0,1.758L12.6,25.119a1.239,1.239,0,0,1-1.758,0L.763,15.038a1.239,1.239,0,0,1,0-1.758l1.151-1.151a1.246,1.246,0,0,1,1.779.021L9.646,18.4V3.495A1.242,1.242,0,0,1,10.891,2.25H12.55a1.242,1.242,0,0,1,1.245,1.245V18.4l5.953-6.249A1.237,1.237,0,0,1,21.526,12.129Z",
  transform: "translate(1554.758 4000.905)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4196",
  "data-name": "Path 4196",
  d: "M3067.906,1407h33.145",
  transform: "translate(-1518 2629.967)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 5
}));

function SvgDownloadArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.145,
    height: 36.312,
    viewBox: "0 0 33.145 36.312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadArrow);
export default __webpack_public_path__ + "static/media/download-arrow.698d6b24.svg";
export { ForwardRef as ReactComponent };